import { useTranslation } from 'react-i18next';
import company1 from '../../assets/images/company1.jpg';
import company2 from '../../assets/images/company2.jpeg';
import company3_eng from '../../assets/images/company3_eng.svg';
import company3_kor from '../../assets/images/company3_kor.svg';
import company4 from '../../assets/images/company4.jpg';
import company5 from '../../assets/images/company5.jpg';
import { scrollToSection } from '../../utils/commonUtils';
import ActionButton from '../common/ActionButton';

export default function CompanySection() {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  return (
    <>
      {/* 콘텐츠 영역 */}
      <section id="company">
        <div className="w-full max-w-[1280px] mx-auto px-6" id="company-section1">
          <div className="flex items-center justify-center py-[100px]">
            <div className="flex flex-col gap-12">
              {/* 1 번째 섹션 */}
              <article className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="relative rounded-full overflow-hidden aspect-square hidden lg:block">
                  <img
                    alt="What is True Cloud?"
                    className="w-full h-full object-cover"
                    src={company1}
                    loading="lazy"
                  />
                </div>
                <div className="space-y-6">
                  <h2 className="text-2xl md:text-4xl font-bold leading-tight">
                    {t('Company.company1.title')}
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-grayText">
                    {t('Company.company1.subtitle')}
                  </p>
                  <ActionButton
                    label={t('common.learnMore')}
                    onClick={() => scrollToSection('solution')}
                    type="black"
                  />
                </div>
              </article>

              {/* 2 번째 섹션 */}
              <article className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="space-y-6">
                  <h2 className="text-2xl md:text-4xl font-bold leading-tight">
                    {t('Company.company2.title')}
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-grayText">
                    {t('Company.company2.subtitle')}
                  </p>
                  <ActionButton
                    label={t('common.learnMore')}
                    onClick={() => scrollToSection('solution')}
                    type="black"
                  />
                </div>
                <div className="relative rounded-full overflow-hidden bg-grayBack aspect-square hidden lg:block">
                  <img
                    alt="Unlock the True Power of Enterprise Cloud"
                    className="w-full h-full object-cover"
                    src={company2}
                    loading="lazy"
                  />
                </div>
              </article>
            </div>
          </div>
        </div>

        {/* 배경 비디오 섹션 (container 영향 받지 않도록 따로 분리) */}
        <div className="w-full">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-[800px] object-cover hidden md:block"
          >
            <source src="/videos/Main_video.mp4" type="video/mp4" />
          </video>
          <video autoPlay loop muted playsInline className="w-full h-[50vh] object-cover md:hidden">
            <source src="/videos/Main_mobile_video.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="w-full max-w-[1280px] mx-auto px-6" id="company-section2">
          <div className="flex items-center justify-center py-[100px]">
            <div className="flex flex-col gap-12">
              {/* 3 번째 섹션 */}
              <article className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="relative overflow-hidden aspect-square hidden lg:flex items-center justify-center">
                  <img
                    alt="company_img3"
                    className="w-full"
                    src={isEnglish ? company3_eng : company3_kor}
                    loading="lazy"
                  />
                </div>
                <div className="space-y-6">
                  <h2 className="text-2xl md:text-4xl font-bold leading-tight">
                    {t('Company.company3.title')}
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-grayText">
                    {t('Company.company3.subtitle')}
                  </p>
                </div>
              </article>

              {/* 4번째 섹션 */}
              <article className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="space-y-6">
                  <h2 className="text-2xl md:text-4xl font-bold leading-tight">
                    {t('Company.company4.title')}
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-grayText">
                    {t('Company.company4.subtitle')}
                  </p>
                </div>
                <div className="relative rounded-full overflow-hidden aspect-square hidden lg:block">
                  <img alt="company_img4" className="w-full" src={company4} loading="lazy" />
                </div>
              </article>

              {/* 5 번째 섹션 */}
              <article className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                <div className="relative rounded-full overflow-hidden aspect-square hidden lg:block">
                  <img alt="company_img5" className="w-full" src={company5} loading="lazy" />
                </div>
                <div className="space-y-6">
                  <h2 className="text-2xl md:text-4xl font-bold leading-tight">
                    {t('Company.company5.title')}
                  </h2>
                  <p className="text-base md:text-lg leading-relaxed text-grayText">
                    {t('Company.company5.subtitle')}
                  </p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
